import React, { Component, Fragment } from "react";

import { LoadPanel } from "devextreme-react/load-panel";
import { SelectBox } from "devextreme-react/select-box";
import { NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getRequestParams,
  getBaseApiUrl,
} from "../../helpers/globalfunctions.js";
import { SketchPicker } from "react-color";
import secureLocalStorage from "react-secure-storage";
import NumberFormat from "react-number-format";

const position = { of: "#historydiv" };
const presetColors = [
  "rgb(0,0,0)",
  "rgb(0,0,255)",
  "rgb(0,255,0)",
  "rgb(255,0,0)",
  "rgb(255,255,255)",
];

export class CreateGeofenceComponent extends Component {
  static displayName = CreateGeofenceComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      loadPanelVisible: false,
      infoWindow: "none",
      geofenceType: [],
      polygonArray: [],
      coordinates: { lat: 18.925480102435305, lng: 72.83210681556199 },
      radius: 500,
      isAdmin:
        secureLocalStorage.getItem("session_userTypeName") === "ADMINISTRATOR"
          ? true
          : false,
      saveBtnDisable: false,
      shapeTypeId: 1,
      //geofenceTypeId : 0,
      poiData: {
        showEditPoiPopup: false,
        id: 0,
        name: "",
        bgColor: "#ed2c13",
        borderColor: "#1a1717",
        geofenceTypeId: 0,
        description: "",
        shapeTypeId: 1,
        radius: 500,
        points: [],
        active: true,
        referenceId: "",
        districtId: 0,
        talukaId: 0,
        overSpeedLimit: 0,
        isRestrictedArea: false,
        disableEntryExitAlerts: false,
      },
      errors: {
        name: "",
        description: "",
        geofenceTypeId: 0,
      },
      isRegisterAsBaseLocation: false,
      address: "",
      showHideColorPicker: false,
      isBgColorField: true,
      districts: [],
      talukas: [],
      isCallFromVehicleReplayPage: false,
    };
    this.handleGeofenceTypeChange = this.handleGeofenceTypeChange.bind(this);
    this.onRadiusChange = this.onRadiusChange.bind(this);
    this.savePoi = this.savePoi.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.closeGeofenceInfo = this.closeGeofenceInfo.bind(this);
    this.showInfo = this.showInfo.bind(this);
    this.cancelPlotBtnClick = this.cancelPlotBtnClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.setPoiData = this.setPoiData.bind(this);
    this.updateMarkerPosition = this.updateMarkerPosition.bind(this);
    this.updatePolygonShap = this.updatePolygonShap.bind(this);
    this.showColorPicker = this.showColorPicker.bind(this);
  }

  componentDidMount() {
    this.getGeofencesType();
    this.getDistricts();
    this.getTalukas();
    this.state.polygonArray = [];
    if (this.state.isAdmin) {
      this.setState({ saveBtnDisable: false });
    }
  }

  closeGeofenceInfo = async (e) => {
    if (e.preventDefault !== undefined) {
      e.preventDefault();
    }
    this.clearState();
    this.setState({ infoWindow: "none" });
    if (!this.state.isAdmin) {
      this.setState({ saveBtnDisable: false });
    }
    this.props.cancelInfo();
  };

  cancelPlotBtnClick = () => {
    this.setState({
      errors: {
        name: "",
        description: "",
        geofenceTypeId: 0,
      },
    });
    this.setState({ infoWindow: "none" });
  };

  showInfo = (data) => {    
    this.clearState();
    this.setState({
      errors: {
        name: "",
        description: "",
        geofenceTypeId: 0,
      },
    });

    if (data.shapeType == 11) {
      this.state.polygonArray.push(data.coordinates);
    }
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.shapeTypeId = data.shapeType;
      return { poiData: prevState };
    });

    this.setState({
      infoWindow: "block",
      coordinates: data.coordinates,
      shapeTypeId: data.shapeType,
      isCallFromVehicleReplayPage: data?.isCallFromVehicleReplayPage ?? false,
    });
  };

  onRadiusChange = (e) => {
    this.setState({ radius: Number(e.target.value) }, () => {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.radius = this.state.radius;
        return { poiData: prevState };
      });
    });
    this.props.onRadiusChange(Number(e.target.value));
  };

  reloadData = () => {
    this.props.reloadData();
  };

  getGeofencesType = async () => {
    try {
      const requestParams = getRequestParams("GET");
      this.setState({
        loadPanelVisible: true,
      });
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + "Geofences/Types",
        requestParams
      );
      const data = await response.json();
      this.setState({
        geofenceType: data.payload != null ? data.payload : [],
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getGeofencesType function",
        err
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };

  getDistricts = async () => {
    try {
      let accountId = secureLocalStorage.getItem("session_accountId");
      let locationId = secureLocalStorage.getItem("session_locationId");
      const requestParams = getRequestParams("GET");
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "District/" +
          accountId +
          "/" +
          locationId,
        requestParams
      );
      const data = await response.json();
      this.setState({
        districts: data.payload != null ? data.payload : [],
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getDistricts function",
        err
      );
    }
  };
  getTalukas = async () => {
    try {      
      let accountId = secureLocalStorage.getItem("session_accountId");
      let locationId = secureLocalStorage.getItem("session_locationId");
      const requestParams = getRequestParams("GET");
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "District/taluka/" +
          this.state.poiData.districtId +
          "/" +
          accountId +
          "/" +
          locationId,
        requestParams
      );
      const data = await response.json();
      this.setState({
        talukas: data.payload != null ? data.payload : [],
      });
    } catch (err) {
      console.log("Error in " + this.displayName + ".getTalukas function", err);
    }
  };

  handleOnDistrictChange = (e) => {    
    this.setState(
      (prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.districtId = e.selectedItem != null ? e.selectedItem.id : 0;
        return { poiData: prevState };
      },
      () => {
        this.getTalukas();
      }
    );
  };

  handleOnTalukaChange = (e) => {
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.talukaId = e.selectedItem != null ? e.selectedItem.id : 0;
      return { poiData: prevState };
    });
  };

  handleGeofenceTypeChange = (e) => {
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.geofenceTypeId = e.selectedItem != null ? e.selectedItem.id : 0;
      return { poiData: prevState };
    });

    // this.setState({
    //     geofenceTypeId: (e.selectedItem != null ? e.selectedItem.id : 0)
    // });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name == "poiNameTxt") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.name = value;
        prevState.description = this.state.isCallFromVehicleReplayPage
          ? value
          : prevState.description;
        return { poiData: prevState };
      });
    }
    if (name == "overSpeedLimit") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.overSpeedLimit = value;
        return { poiData: prevState };
      });
    }

    if (name == "isRestrictedArea") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.isRestrictedArea = value;
        return { poiData: prevState };
      });
    }
    if (name == "disableEntryExitAlerts") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.disableEntryExitAlerts = value;
        return { poiData: prevState };
      });
    }
    if (name == "polyBgTxt") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.bgColor = value;
        return { poiData: prevState };
      });
    }

    if (name == "polyBorderTxt") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.borderColor = value;
        return { poiData: prevState };
      });
    }

    if (name == "descriptionTxt") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.description = value;
        return { poiData: prevState };
      });
    } else if (name == "referenceId") {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.referenceId = value;
        return { poiData: prevState };
      });
    }

    if (name == "isRegisterAsBaseLocation") {
      this.setState({ isRegisterAsBaseLocation: value });
    }
    if (name == "isVisibleOnMap") {
        this.setState({ isVisibleOnMap: value });
    }
    if (name == "address") {
      this.setState({ address: value });
    }
  }

  updateMarkerPosition = (latitude, longitude) => {
    var points = [];
    points.push({
      GeofenceId: this.state.poiData.geofenceTypeId,
      Latitude: latitude,
      Longitude: longitude,
      SequenceId: 0,
      Radius: this.state.radius,
    });
    this.setState({ radius: this.state.radius });
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.points = [];
      prevState.points = points;
      return { poiData: prevState };
    });
  };

  updatePolygonShap = (coordinates) => {
    var points = [];
    for (var i = 0; i < coordinates.length; i++) {
      let position = coordinates.getAt(i);
      points.push({
        GeofenceId: this.state.poiData.geofenceTypeId,
        Latitude: position.lat(),
        Longitude: position.lng(),
        SequenceId: i,
        Radius: 0,
      });
    }
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.points = [];
      prevState.points = points;
      return { poiData: prevState };
    });
  };

  setPoiData = (data) => {
    this.setState(
      (prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.showEditPoiPopup = true;
        prevState.id = data.id;
        prevState.name = data.name;
        prevState.bgColor = data.bgColor;
        prevState.borderColor = data.borderColor;
        prevState.description = data.description;
        prevState.geofenceTypeId = data.geofenceTypeId;
        prevState.shapeTypeId = data.shapeTypeId;
        prevState.radius = data.radius;
        prevState.points = data.points;
        prevState.active = data.active;
        prevState.referenceId = data.referenceId;
        prevState.districtId = data.districtId;
        prevState.talukaId = data.talukaId;
        prevState.overSpeedLimit = data.overSpeedLimit;
        prevState.isRestrictedArea = data.isRestrictedArea;
        prevState.disableEntryExitAlerts = data.disableEntryExitAlerts;
        return { poiData: prevState };
      },
      () => {
        if (data.isByMap) {
          this.setState({
            infoWindow: "block",
            radius: data.radius,
            shapeTypeId: data.shapeTypeId,
          });
        } else {
          this.savePoi();
        }
      }
    );
    if (data != null && this.state.isAdmin) {
      this.setState({ saveBtnDisable: false });
    } else {
      this.setState({ saveBtnDisable: true });
    }
  };

  handleValidation() {
    let formIsValid = true;
    try {
      let errors = this.state.errors;
      errors.name = "";
      errors.description = "";
      errors.geofenceTypeId = 0;
      this.setState({ message: "" });

      if (this.state.poiData.name === "") {
        formIsValid = false;
        errors.name = "POI Name Required.";
      }
      if (this.state.poiData.description === "") {
        formIsValid = false;
        errors.description = "Description Required.";
      }

      if (this.state.poiData.geofenceTypeId === 0) {
        formIsValid = false;
        errors.geofenceTypeId = "Geofence Type Required.";
      }

      this.setState({ errors: errors });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleValidation function",
        err
      );
      formIsValid = false;
    }
    return formIsValid;
  }

  savePoi = async () => {
    try {
      // if (this.state.poiData.name == null ||  this.state.poiData.name == '' ) {
      //     alert("POI Name Required.");
      //     return false;
      // }
      // if (this.state.poiData.description == null || this.state.poiData.description == '' ) {
      //     alert("Description Required.");
      //     return false;
      // }
      var points = [];      
      if (this.state.poiData.id == 0) {
        if (this.state.poiData.shapeTypeId == 1) {
          points.push({
            GeofenceId: this.state.geofenceTypeId,
            Latitude: this.state.coordinates.lat(),
            Longitude: this.state.coordinates.lng(),
            SequenceId: 0,
            Radius: this.state.radius,
          });
        } else {
          this.state.polygonArray.map((item) => {
            points.push({
              GeofenceId: this.state.geofenceTypeId,
              Latitude: item.lat(),
              Longitude: item.lng(),
              SequenceId: 0,
              Radius: 0,
            });
          });
          let firstItem = this.state.polygonArray[0];
          points.push({
            GeofenceId: this.state.geofenceTypeId,
            Latitude: firstItem.lat(),
            Longitude: firstItem.lng(),
            SequenceId: 0,
            Radius: 0,
          });
        }
      } else {
        if (this.state.poiData.shapeTypeId == 1) {
          points.push({
            GeofenceId: this.state.poiData.points[0].GeofenceId,
            Latitude: this.state.poiData.points[0].Latitude,
            Longitude: this.state.poiData.points[0].Longitude,
            SequenceId: 0,
            Radius: this.state.radius,
          });
        } else {
          points = this.state.poiData.points;
        }
      }

      if (this.handleValidation()) {
        let alertmesage =
          this.state.poiData.id == 0
            ? "Are you sure, you want create poi?"
            : "Are you sure, you want to update poi?";
        Swal.fire({
          html: alertmesage,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.callSavePoiApi(points);
          }
        });
      }
    } catch (err) {
      console.log("Error in " + this.displayName + ".savePoi function", err);
    }
  };

  callSavePoiApi = async (points) => {
    try {
      this.setState({
        loadPanelVisible: true,
      });
      var request = {};      
      request.id = this.state.poiData.id;
      request.AccountId = secureLocalStorage.getItem("session_accountId");
      request.LocationId = secureLocalStorage.getItem("session_locationId");
      request.UserId = secureLocalStorage.getItem("session_userId");
      request.GeofenceTypeId = this.state.poiData.geofenceTypeId;
      request.ShapeTypeId = this.state.poiData.shapeTypeId;
      request.Points = points;
      request.Name = this.state.poiData.name.trim();
      request.Active = this.state.poiData.active;
      request.PolyBgColor = this.state.poiData.bgColor;
      request.PolyBorderColor = this.state.poiData.borderColor;
      request.Description = this.state.poiData.description;
      request.IsRegisterAsBaseLocation = this.state.isRegisterAsBaseLocation;
      request.isVisibleOnMap = this.state.isVisibleOnMap; // add this line to save visibility on map (api change required)
      request.Address = this.state.address;
      request.Radius = this.state.radius;
      request.ReferenceId = this.state.poiData.referenceId;
      request.DistrictId = this.state.poiData.districtId;
      request.TalukaId = this.state.poiData.talukaId;
      request.overSpeedLimit = this.state.poiData.overSpeedLimit;
      request.isRestrictedArea = this.state.poiData.isRestrictedArea;
      request.disableEntryExitAlerts =
        this.state.poiData.disableEntryExitAlerts;
      const requestParams = getRequestParams("POST", request);
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + "Geofences",
        requestParams
      );
      const result = await response.json();
      this.setState({ loadPanelVisible: false });
      if (result.isSuccess) {
        this.clearState();
        Swal.fire({
          icon: result.isSuccess ? "success" : "error",
          title: result.isSuccess ? "Success" : "Oops...",
          text: result.message,
        }).then((result) => {
          if (result.isConfirmed) {
            this.props.closeModal();
            this.props.cancelInfo();
            this.clearState();
            this.reloadData();
          }
          this.setState({ isSubmited: false });
        });

        // Swal.fire(result.message);
        //  this.props.closeModal();
        // this.reloadData();
      } else {
        Swal.fire(result.message);
        return;
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".callSavePoiApi function",
        err
      );
      this.setState({ loadPanelVisible: false });
    }
  };

  clearState = () => {
    this.setState((prevState) => {
      prevState = JSON.parse(JSON.stringify(this.state.poiData));
      prevState.showEditPoiPopup = false;
      prevState.id = 0;
      prevState.name = "";
      prevState.bgColor = "#ed2c13";
      prevState.borderColor = "#1a1717";
      prevState.description = "";
      prevState.geofenceTypeId = 0;
      prevState.shapeTypeId = 1;
      prevState.radius = 500;
      prevState.points = [];
      prevState.districtId = 0;
      prevState.talukaId = 0;
      return { poiData: prevState };
    });

    this.setState({
      errors: {
        name: "",
        description: "",
        geofenceTypeId: 0,
      },
      showHideColorPicker: false,
      isRegisterAsBaseLocation: false,
      address: "",
    });
  };

  handleColorChangeComplete = (color) => {
    if (this.state.isBgColorField) {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.bgColor = color.hex;
        return { poiData: prevState };
      });
    } else {
      this.setState((prevState) => {
        prevState = JSON.parse(JSON.stringify(this.state.poiData));
        prevState.borderColor = color.hex;
        return { poiData: prevState };
      });
    }
  };

  showColorPicker = (isBgColorField) => {
    let isShow = this.state.showHideColorPicker ? false : true;
    this.setState({
      showHideColorPicker: isShow,
      isBgColorField: isBgColorField,
    });
  };

  render() {
    return (
      <Fragment>
        {
          <div
            className="vehicle-info"
            style={{ display: this.state.infoWindow }}
          >
            <div
              className="card rounded-vlg mb-0 shadow-lg"
              id="geofenceCard-dimiss"
            >
              <div className="card-header-action">
                <a
                  className="bg-danger rounded-circle"
                  onClick={(e) => {
                    this.closeGeofenceInfo(e);
                  }}
                  href="#"
                >
                  <i className="fas fa-times"></i>
                </a>
              </div>
              {/* <div className="card-header-action">
                            <a data-dismiss="#geofenceCard-dimiss" className="bg-danger rounded-circle" onClick={(e) => { this.closeGeofenceInfo(e) }} href="#"><i className="fas fa-times"></i></a>
                    </div> */}
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="poiName" className="mb-0">
                        POI Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="poiNameTxt"
                        value={this.state.poiData.name}
                        onChange={this.handleInputChange}
                      />
                      {this.state.errors["name"].length > 0 && (
                        <span className="error-msg">
                          {this.state.errors["name"]}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-0">Reference No :</label>
                      <input
                        type="text"
                        className="form-control"
                        name="referenceId"
                        value={this.state.poiData.referenceId}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      display: this.state.shapeTypeId == 1 ? "block" : "none",
                    }}
                  >
                    <input
                      type="range"
                      step="50"
                      max="1000"
                      id="radiusTxt"
                      name="radiusTxt"
                      value={this.state.radius}
                      onChange={(e) => {
                        this.onRadiusChange(e);
                      }}
                    />
                    &nbsp;
                    <span>Radius: {this.state.radius} m</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="geofenceTypeId" className="mb-0">
                        Select Geofence Type
                      </label>
                      <SelectBox
                        dataSource={
                          this.state.geofenceType.length > 0
                            ? this.state.geofenceType
                            : []
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Geofence Type"
                        name="name"
                        defaultValue={0}
                        value={this.state.poiData.geofenceTypeId}
                        displayExpr="name"
                        valueExpr="id"
                        onSelectionChanged={this.handleGeofenceTypeChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        width="100%"
                      />
                      {this.state.errors["geofenceTypeId"].length > 0 && (
                        <span className="error-msg">
                          {this.state.errors["geofenceTypeId"]}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="districtId" className="mb-0">
                        Select District
                      </label>
                      <SelectBox
                        dataSource={this.state.districts}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select District"
                        name="districts"
                        defaultValue={0}
                        value={this.state.poiData.districtId}
                        displayExpr="name"
                        valueExpr="id"
                        onSelectionChanged={this.handleOnDistrictChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        width="100%"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="talukaId" className="mb-0">
                        Select Taluka
                      </label>
                      <SelectBox
                        dataSource={this.state.talukas}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Taluka"
                        name="talukas"
                        defaultValue={0}
                        value={this.state.poiData.talukaId}
                        displayExpr="name"
                        valueExpr="id"
                        onSelectionChanged={this.handleOnTalukaChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        width="100%"
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <NavLink
                      tag={Link}
                      to="#"
                      title="show/hide color palette"
                      onClick={() => {
                        this.showColorPicker(true);
                      }}
                      className="color-swatch"
                    >
                      <input
                        type="text"
                        readOnly
                        style={{
                          backgroundColor: this.state.poiData.bgColor,
                          width: "24px",
                          height: "20px",
                          boxSixing: "border-box",
                          borderWidth: "3px",
                          borderStyle: "solid",
                          borderColor: "black",
                          padding: "1px 2px",
                          borderImage: "initial",
                          cursor: "pointer",
                        }}
                      ></input>
                    </NavLink>
                    <label htmlFor="polyBgTxt" className="m-2">
                      Background Color
                    </label>
                    <div
                      className="color-palette"
                      style={{
                        display: this.state.showHideColorPicker
                          ? "block"
                          : "none",
                      }}
                    >
                      <SketchPicker
                        display="none"
                        color={this.state.poiData.bgColor}
                        onChangeComplete={this.handleColorChangeComplete}
                      />
                    </div>
                  </div>

                  <div className="col-6">
                    <NavLink
                      tag={Link}
                      to="#"
                      title="show/hide color palette"
                      onClick={() => {
                        this.showColorPicker(false);
                      }}
                      className="color-swatch"
                    >
                      <input
                        type="text"
                        readOnly
                        style={{
                          backgroundColor: this.state.poiData.borderColor,
                          width: "24px",
                          height: "20px",
                          boxSixing: "border-box",
                          borderWidth: "3px",
                          borderStyle: "solid",
                          borderColor: "black",
                          padding: "1px 2px",
                          borderImage: "initial",
                          cursor: "pointer",
                        }}
                      ></input>
                    </NavLink>
                    <label htmlFor="polyBorderTxt" className="m-2">
                      Border Color
                    </label>
                  </div>
                  {!this.state.isCallFromVehicleReplayPage && (
                    <>
                      <div className="col-12">
                        <div className="form-group">
                          <label htmlFor="descriptionTxt" className="mb-0">
                            Description
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="descriptionTxt"
                            value={this.state.poiData.description}
                            onChange={this.handleInputChange}
                          />
                          {this.state.errors["description"].length > 0 && (
                            <span className="error-msg">
                              {this.state.errors["description"]}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-group">
                          <label className="mb-0">OverSpeed Limit</label>
                          <NumberFormat
                            className="form-control"
                            name="overSpeedLimit"
                            placeholder="0"
                            maxLength="6"
                            title="overSpeedLimit"
                            value={this.state.poiData.overSpeedLimit}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-group">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isRestrictedArea"
                            checked={this.state.poiData.isRestrictedArea}
                            onChange={this.handleInputChange}
                          />
                          <label className="mb-0"> Is Restricted Area</label>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-group">
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="disableEntryExitAlerts"
                            checked={this.state.poiData.disableEntryExitAlerts}
                            onChange={this.handleInputChange}
                          />
                          <label className="mb-0">
                            Disable Entry Exit Alerts
                          </label>
                        </div>
                      </div>

                      <div
                        className="col-6"
                        style={{
                          display:
                            this.state.poiData.id == 0 ? "block" : "none",
                        }}
                      >
                        <div className="form-group">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isRegisterAsBaseLocation"
                            checked={this.state.isRegisterAsBaseLocation}
                            onChange={this.handleInputChange}
                          />
                          <label className="mb-0">
                            Register As Base Location
                          </label>
                        </div>
                        <div className="form-group">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isVisibleOnMap"
                            checked={this.state.isVisibleOnMap}
                            onChange={this.handleInputChange}
                          />
                          <label className="mb-0">
                            Make Visible On Map
                          </label>
                        </div>
                      </div>
                      <div
                        className="col-12"
                        style={{
                          display: this.state.isRegisterAsBaseLocation
                            ? "block"
                            : "none",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="descriptionTxt" className="mb-0">
                            Address :
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            name="address"
                            value={this.state.address}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className="col-12"
                    style={{ marginLeft: "-5px", marginTop: "8px" }}
                  >
                    <div className=" modal-footer">
                      <button
                        type="button"
                        disabled={this.state.saveBtnDisable}
                        className="btn btn-success"
                        onClick={() => this.savePoi()}
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        className="btn btn-custom-gray"
                        onClick={(e) => this.closeGeofenceInfo(e)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </Fragment>
    );
  }
}
